// ============================================================================
// MASTER OPTIONS SERVICE
// ============================================================================

import { get } from '../client/axiosClient';
import { masterOptionsEndpoints } from '../endpoints/masterOptions.endpoints';
import type { ApiResponse } from '../types';
import type { MasterOption } from '../types/masterOptions.types';

class MasterOptionsService {
  async get(masterCode: string, filter?: string): Promise<MasterOption[]> {
    const response = await get<ApiResponse<MasterOption[]>>(masterOptionsEndpoints.get(masterCode, filter));
    return response.data?.data ?? [];
  }
}

export const masterOptionsService = new MasterOptionsService();
export default masterOptionsService;
